export const getGqlEndpoint = () => {
    if (process.env.NODE_ENV === 'development') {
        return '/bff/api/graphql';
    } else {
        return '/bff/api/graphql';
    }
};
